import { render, staticRenderFns } from "./ChangePaymentTypeModal.vue?vue&type=template&id=2c600d32"
import script from "./ChangePaymentTypeModal.vue?vue&type=script&lang=js"
export * from "./ChangePaymentTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports